module.exports = __webpack_public_path__ + "img/carousel-clientes-4.6d931515.png";